import React from 'react';
import FeatureCards from "../../../components/FeatureCards/FeatureCards";
import CTA from "../../../components/Constant/cta/CTA";
import TimelineSection from "../../../components/TimelineSection/TimelineSection";
import WhySection from "../../../components/WhySection/WhySection";
import LocationTimeline from "../../../components/LocationTimeline/LocationTimeline";
import IntroSection from "../../../components/IntroSection/IntroSection";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../../components/ServiceCards/ServiceCards";

export default function FundsAssetManagementIsleMan() {

    return (
        <main className='main'>
            <IntroSection
                title="Funds & Asset Management – Isle of Man"
                subtitle="A Tier-1 Jurisdiction for Hedge Funds, Private Funds & Managers"
                description="The Isle of Man is an established financial hub for fund managers, investment companies, and asset management structures, offering regulatory options that balance credibility with flexibility. Supervised by the IOMFSA, Isle of Man funds are attractive to hedge funds, private equity, family offices, and boutique managers seeking an internationally recognized base."
                badges={[
                    "Hedge Funds",
                    "Private Funds",
                    "UCITS-Equivalent Structures",
                    "Fund Managers"
                ]}
                buttonText="Request an Isle of Man Fund Proposal →"
                buttonLink="/quote"
                imageSrc={require("../../../assets/images/services/funds-asset-management-isle-man-hero.png")}
                imageAlt="Isle of Man Funds & Asset Management"
            />

            <section className='section'>
                <div className="container">

                    <WhySection
                        title='Why Choose Isle of Man for Funds?'
                        blocks={
                            [
                                {
                                    items:
                                        [
                                            {
                                                title: "Tier-1 Reputation",
                                                text: "Trusted globally, especially in Europe and Commonwealth markets."
                                            },
                                            {
                                                title: "Regulatory Flexibility",
                                                text: "Multiple fund classes (regulated and unregulated)."
                                            },
                                            {
                                                title: "Cost-Effective",
                                                text: "Cheaper than Cayman or Luxembourg while maintaining credibility."
                                            },
                                            {
                                                title: "Range of Options",
                                                text: "Suitable for small private funds to institutional UCITS equivalents."
                                            },
                                            {
                                                title: "Crypto & Blockchain Friendly",
                                                text: "Isle of Man supports digital asset funds."
                                            }
                                        ]
                                }
                            ]
                        }
                    />

                    <InfoBlocks
                        title="Types of Fund Structures in Isle of Man"
                        blocks={[
                            {
                                title: "Regulated Funds (IOMFSA Supervised)",
                                items: [
                                    { text: "For institutional or retail investors." },
                                    { text: "Includes Authorised Collective Investment Schemes (CIS)." },
                                    { text: "Higher compliance but maximum credibility." }
                                ]
                            },
                            {
                                title: "Experienced Investor Funds (EIFs)",
                                items: [
                                    { text: "For sophisticated investors only." },
                                    { text: "Lower compliance requirements." }
                                ]
                            },
                            {
                                title: "Professional Investor Funds (PIFs)",
                                items: [
                                    { text: "For professional/qualified investors." },
                                    { text: "Minimum entry ticket, lighter regulatory burden." }
                                ]
                            },
                            {
                                title: "Unregulated Funds (Exempt Schemes)",
                                items: [
                                    { text: "For private arrangements with fewer than 50 investors." },
                                    { text: "Often used by family offices and private equity structures." }
                                ]
                            },
                            {
                                title: "Fund Manager & Administrator Licenses",
                                items: [
                                    { text: "Required for portfolio managers, asset managers, and fund administrators." }
                                ]
                            }
                        ]}
                    />

                    <LocationTimeline
                        title="Capital & Requirements"
                        item={
                            [
                                {
                                    title: "Funds Capital Requirement",
                                    text: "Minimum capital depends on structure (regulated funds require higher capital)."
                                },
                                {
                                    title: "Fund Managers Capital",
                                    text: "GBP 50,000–100,000 capital required."
                                },
                                {
                                    title: "Entity Requirement",
                                    text: "Isle of Man-incorporated company or limited partnership."
                                },
                                {
                                    title: "Resident Presence",
                                    text: "2 local directors plus a compliance officer required."
                                },
                                {
                                    title: "Custodian",
                                    text: "Mandatory for regulated or public funds."
                                },
                                {
                                    title: "Audit",
                                    text: "Annual audits required for regulated funds."
                                }
                            ]
                        }
                    />

                    <ServiceCards
                        title='Benefits of Isle of Man Funds'
                        services={
                            [
                                {
                                    title: "Prestige",
                                    text: "Tier-1 recognition with investors and banks."
                                },
                                {
                                    title: "Choice of Structures",
                                    text: "From light-touch private funds to regulated CIS."
                                },
                                {
                                    title: "Crypto & Digital Assets Welcome",
                                    text: "Regulated funds can hold crypto."
                                },
                                {
                                    title: "Scalable",
                                    text: "Suitable for boutique managers or global asset firms."
                                },
                                {
                                    title: "Tax Benefits",
                                    text: "0% corporate tax, no capital gains tax."
                                }
                            ]
                        }
                    />

                    <FeatureCards
                        title='Licensing Process'
                        features={
                            [
                                {
                                    title: "Pre-Application Consultation",
                                    text: "Select fund type."
                                },
                                {
                                    title: "Entity Incorporation",
                                    text: "Set up Isle of Man company or limited partnership."
                                },
                                {
                                    title: "Application Preparation",
                                    text: "Prepare prospectus, AML/KYC, and fund documents."
                                },
                                {
                                    title: "IOMFSA Review",
                                    text: "Regulator conducts due diligence on promoters, directors, and managers."
                                },
                                {
                                    title: "Approval & Launch",
                                    text: "Typically 3–6 months."
                                }
                            ]
                        }
                    />

                    <TimelineSection
                        title='Timeline & Costs'
                        items={
                            [
                                {
                                    name: "Timeline",
                                    duration: "3–6 months.",
                                },
                                {
                                    name: "Setup Costs",
                                    description: "from GBP 60,000+ (depending on fund type)."
                                },
                                {
                                    name: "Annual Costs",
                                    description: "audit, compliance, IOMFSA fees."
                                },
                            ]
                        }
                    />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    <CTA
                        title="Looking to launch a private fund, hedge fund, or asset management company?"
                        description="The Isle of Man offers flexible fund structures under IOMFSA, trusted globally by investors."
                        buttonText="Book an Isle of Man Fund Consultation →"
                        buttonLink="/quote"
                    />
                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "What is the most common IoM fund type?",
        content: [
            { type: "answer", text: "Private and Professional Investor Funds — lighter regulation, fast setup." },
        ],
    },
    {
        question: "Do funds require a custodian?",
        content: [
            { type: "answer", text: "Yes, for regulated/public funds. Not mandatory for private funds." },
        ],
    },
    {
        question: "Can IoM funds invest in crypto?",
        content: [
            { type: "answer", text: "Yes — IoM is crypto-friendly." },
        ],
    },
    {
        question: "How does IoM compare to Cayman?",
        content: [
            { type: "answer", text: "IoM offers Tier-1 recognition at lower costs, with EU alignment." },
        ],
    },
    {
        question: "How long does it take to license a fund?",
        content: [
            { type: "answer", text: "3–6 months." },
        ],
    },
];

const testimonialsData = [
    {
        quote: "We launched a hedge fund in IoM to attract EU investors. Offshore Advisory managed the full setup with IOMFSA.",
        author: "Mark J.",
        role: "Fund Manager"
    },
    {
        quote: "The Isle of Man private fund structure was perfect for our family office. Offshore Advisory handled everything.",
        author: "Sophia W.",
        role: "Investor"
    }
];
